// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"258":"client-form","873":"online-devices","930":"tables"}[chunkId] || chunkId) + "." + {"258":"4b416cde","312":"e98472b5","611":"707a28b2","873":"d2cab37c","930":"de001f5f","989":"73a4a260"}[chunkId] + ".css";
};